import MuiIconButton, {
  IconButtonProps as MuiIconButtonProps,
} from '@mui/material/IconButton';
import { Tooltip } from '../display';
import Icon, { IconName } from '../display/Icon';
import { Size, useAsyncHandler } from '../utils';
import classes from './IconButton.module.scss';

export default function IconButton({
  buttonSize = 'medium',
  children,
  color = 'primary',
  icon,
  size = 'medium',
  onClick,
  title = '',
  ...rest
}: IconButtonProps) {
  const [clickHandler, isProcessing] = useAsyncHandler({ handler: onClick });

  const content = (
    <MuiIconButton
      color={color}
      disabled={isProcessing}
      onClick={clickHandler}
      size={buttonSize}
      {...rest}
    >
      {icon && <Icon icon={icon} size={size} sx={{ mr: 0 }} />}
      {children && <span className={classes.content}>{children}</span>}
    </MuiIconButton>
  );

  if (!title) {
    return content;
  }

  return <Tooltip title={title}>{content}</Tooltip>;
}

export interface IconButtonProps extends Omit<MuiIconButtonProps, 'size'> {
  buttonSize?: 'medium' | 'small';
  icon?: IconName;
  size?: Size;
}
